module.exports = __webpack_public_path__ + "media/images/front/team/sonia_lopez-5b1710a2bce3a958385a98eb5dc381b9.jpg";